import { SUPPORTED_LNGS } from "../i18n";

export function getLanguageCode(i18nLanguage: string) {
  return i18nLanguage?.substring(0, 2);
}

export const LANGUAGE_STORAGE_KEY = "NEXT_LOCALE";
export const USER_SELECTED_LANGUAGE_KEY = "NEXT_LOCALE_USER_SELECTED";

export function getForcedLanguage(params: URLSearchParams): string | null {
  const demande = params.get("language");
  if (!demande) return null;

  return (
    SUPPORTED_LNGS.find((lng) => lng.toLowerCase() === demande.toLowerCase()) ??
    null
  );
}

export function getCookieDomain(): string | undefined {
  if (typeof window === "undefined") return undefined;

  const hostParts = window.location.hostname.split(".");
  if (hostParts.length > 2) {
    return `.${hostParts.slice(hostParts.length - 2).join(".")}`;
  } else if (hostParts.length === 2) {
    return `.${window.location.hostname}`;
  }
  return undefined;
}

// Cookie de domaine : le localStorage ne traverse pas les sous-domaines.
function markUserSelectedCookie(): void {
  const domain = getCookieDomain();
  const secure = window.location.protocol === "https:";

  document.cookie = [
    `${USER_SELECTED_LANGUAGE_KEY}=true`,
    "path=/",
    `max-age=${60 * 60 * 24 * 365}`,
    domain ? `domain=${domain}` : "",
    secure ? "secure" : "",
    `samesite=${secure ? "none" : "lax"}`,
  ]
    .filter(Boolean)
    .join("; ");
}

export function persistLanguageToStorage(
  language: string,
  isUserSelected: boolean = false
): void {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    if (isUserSelected) {
      localStorage.setItem(USER_SELECTED_LANGUAGE_KEY, "true");
    }
  } catch (error) {
    console.warn("Failed to save language to localStorage:", error);
  }

  if (isUserSelected) {
    markUserSelectedCookie();
  }
}

export function hasUserSelectedLanguage(): boolean {
  if (typeof window === "undefined") return false;

  if (
    new RegExp(`(?:^|; )${USER_SELECTED_LANGUAGE_KEY}=true`).test(
      document.cookie
    )
  ) {
    return true;
  }

  try {
    return localStorage.getItem(USER_SELECTED_LANGUAGE_KEY) === "true";
  } catch {
    return false;
  }
}
